import React, { ButtonHTMLAttributes, FC, MouseEvent } from "react";
import { joinClassNames as c } from "Shared/util/styles";
import Spinner from "./spinner";
import styles from "./button.css";

export type ButtonAttributes = {
    disabled?: boolean;
    type?: ButtonHTMLAttributes<any>["type"];
};

export type ButtonType =
    | "action-primary"
    | "action-secondary"
    | "button-primary"
    | "button-secondary";

type ButtonProps = {
    attributes?: ButtonAttributes;
    buttonType?: ButtonType;
    className?: string;
    isLoading?: boolean;
    onClick?: (event?: MouseEvent<HTMLButtonElement>) => void;
    small?: boolean;
    text?: string;
};

const getButtonTypeClass = (type: ButtonType | undefined) => {
    switch (type) {
        case "action-primary":
            return styles.actionPrimary;

        case "action-secondary":
            return styles.actionSecondary;

        case "button-primary":
            return styles.buttonPrimary;

        case "button-secondary":
            return styles.buttonSecondary;

        default:
            return styles.buttonPrimary;
    }
};

const Button: FC<ButtonProps> = ({
    attributes,
    buttonType,
    className,
    isLoading,
    onClick,
    small,
    text,
}) => {
    const buttonText = (
        <span className={styles.textPrimary}>
            {isLoading ? (
                <>
                    <Spinner customClass={styles.spinner} />
                    <div className={styles.hiddenMaxWidth}>{text}</div>
                </>
            ) : (
                text
            )}
        </span>
    );

    return (
        <button
            className={c(
                styles.button,
                getButtonTypeClass(buttonType),
                small && styles.small,
                !!attributes?.disabled && styles.disabled,
                isLoading && styles.loading,
                className,
            )}
            type={attributes?.type || "button"}
            {...(onClick && { onClick })}
            {...attributes}
        >
            {buttonText}
        </button>
    );
};

export default Button;
